export const MEASURES_SET = 'MEASURES_SET';
export const measuresSet = (data) => ({ type: MEASURES_SET, payload: data });
